var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9418 6.84532C11.4103 6.57072 11.9906 6.57072 12.459 6.84532L21.0925 11.9064C22.0811 12.4859 22.0811 13.9149 21.0925 14.4944L12.459 19.5555C11.9906 19.8301 11.4103 19.8301 10.9418 19.5555L2.30832 14.4944C1.31976 13.9149 1.31976 12.4859 2.30832 11.9064L10.9418 6.84532Z",
    fill: "#C3E4EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9418 3.64317C11.4103 3.36857 11.9906 3.36857 12.459 3.64317L21.0925 8.7042C22.0811 9.2837 22.0811 10.7128 21.0925 11.2923L12.459 16.3533C11.9906 16.6279 11.4103 16.6279 10.9418 16.3533L2.30832 11.2923C1.31976 10.7128 1.31976 9.2837 2.30832 8.7042L10.9418 3.64317Z",
    fill: "#85BFD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9418 0.444685C11.4103 0.170081 11.9906 0.17008 12.459 0.444684L21.0925 5.50572C22.0811 6.08522 22.0811 7.51431 21.0925 8.09381L12.459 13.1548C11.9906 13.4294 11.4103 13.4294 10.9418 13.1548L2.30832 8.09381C1.31976 7.51431 1.31976 6.08522 2.30832 5.50572L10.9418 0.444685Z",
    fill: "#0B7A9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHb);
export default __webpack_public_path__ + "static/media/hb.55279bec62085eb83356b5e80d9adef4.svg";
export { ForwardRef as ReactComponent };